import React from 'react';
import NavigationBar from '../NavigationBar';

// Party Health dashboard. The page itself is a standalone HTML file (public/reports/party-health.html,
// sample data for now) shown under the navbar.
function PartyHealth() {
    return (
        <>
            <NavigationBar />
            <iframe
                title="Party Health"
                src="/reports/party-health.html"
                style={{ display: 'block', width: '100%', height: 'calc(100vh - 56px)', border: 0 }}
            />
        </>
    );
}

export default PartyHealth;
